function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.99997 13H3.99997V20C3.99997 21.103 4.89697 22 5.99997 22H18C19.103 22 20 21.103 20 20V13H21C21.1977 13 21.391 12.9413 21.5554 12.8314C21.7198 12.7215 21.848 12.5654 21.9236 12.3827C21.9993 12.2 22.0191 11.9989 21.9806 11.805C21.942 11.611 21.8468 11.4329 21.707 11.293L12.707 2.293C12.6142 2.20005 12.504 2.12632 12.3827 2.07601C12.2613 2.02569 12.1313 1.9998 12 1.9998C11.8686 1.9998 11.7386 2.02569 11.6173 2.07601C11.496 2.12632 11.3858 2.20005 11.293 2.293L2.29297 11.293C2.15316 11.4329 2.05795 11.611 2.01939 11.805C1.98082 11.9989 2.00062 12.2 2.07629 12.3827C2.15196 12.5654 2.2801 12.7215 2.44451 12.8314C2.60892 12.9413 2.80222 13 2.99997 13ZM9.99997 20V15H14V20H9.99997ZM12 4.414L18 10.414V15L18.001 20H16V15C16 13.897 15.103 13 14 13H9.99997C8.89697 13 7.99997 13.897 7.99997 15V20H5.99997V10.414L12 4.414Z",
  fill: "current"
});

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-icon.b24181d1.svg";
export { ForwardRef as ReactComponent };